/** Public site navigation: one list for the header, the menu sheet and the footer. */
export const SITE_NAV = [
  { to: "/", label: "الرئيسية" },
  { to: "/bousala", label: "البوصلة الدراسية", free: true },
  { to: "/blog", label: "المدوّنة" },
  { to: "/about", label: "من نحن" },
  { to: "/contact", label: "التواصل" },
] as const;

export function isNavActive(to: string, pathname: string) {
  return to === "/" ? pathname === "/" : pathname === to || pathname.startsWith(`${to}/`);
}
